import type { Match } from '@atlassian/react-resource-router';
import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';

// oxlint-disable-next-line typescript/no-invalid-void-type
export const useMatch: (args_0: void) => Match = createRouterSelector((state) => state.match);
